// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__Md--V","tabs":"Gallery_tabs__v12vK","activeTab":"Gallery_activeTab__em7PK","imageGallery":"Gallery_imageGallery__1LC0J"};